import { isNil } from 'lodash';
import { normaliseComputedCellValue } from '../../dataUtils/cell/tableCellRenderValueUtils';
import hyperFormulaInstance from '../../../manager/hyperFormulaInstance';
import { isFormula } from '../../dataUtils/formula/tableFormulaPredicateUtils';
import { getHotTableCellData } from '../meta/hotTableCellMetaUtils';
import type { MNHotInstance } from '../../../tableHotInstanceTypes';

/**
 * Reads a HoT cell and returns the normalized computed value used by Milanote.
 */
export const getNormalisedComputedCellValueFromHot = (
    elementId: string,
    row: number | undefined,
    col: number | undefined,
    hot: MNHotInstance,
) => {
    if (isNil(row) || isNil(col)) return null;

    const hotComputedCellValue = hot.getDataAtCell(row, col);
    const cellData = getHotTableCellData(hot, { row, col });
    const cellValue = cellData?.value;
    if (!cellValue || !isFormula(cellValue)) return hotComputedCellValue;

    const sheet = hyperFormulaInstance.getSheetId(elementId);
    if (isNil(sheet)) return hotComputedCellValue;

    const cellFormulaInfo = {
        hfType: hyperFormulaInstance.getCellType({ sheet, row, col }),
        hfDetailedType: hyperFormulaInstance.getCellValueDetailedType({ sheet, row, col }),
    };

    // @ts-ignore - custom property
    const { locale } = hot.milanoteProps;

    return normaliseComputedCellValue(hotComputedCellValue, locale, cellFormulaInfo);
};
